import { createAction } from '@reduxjs/toolkit';
import { GET_DICTIONARIES_COMPETENCE_TEMP } from '../actionConstants';

export const getAllCompetenceTemp = createAction(
  GET_DICTIONARIES_COMPETENCE_TEMP
);
